const targetImageControlComponent = {
    schema: {
      images: {type: 'array', default: []},
    },
    init() {
      // console.log('images', this.data.images)
      window.XR8.XrController.configure({imageTargets: this.data.images})
    },
  }
  
  export {targetImageControlComponent}
  